import React, { Fragment, useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import EnquiryListPanel from "./EnquiryListPanel";

function matchesHistoryStatusFilter(item, filterId) {
  if (filterId === "all") return true;
  return item?.status === filterId;
}

function EnquiriesHistory({
  keyword,
  searchDate,
  activeTab,
  statusFilter = "all",
}) {
  const { reservationLoading, enquiriesHistory } = useContext(AppContext);
  const [displayList, setDisplayList] = useState(null);

  useEffect(() => {
    if (!enquiriesHistory) return;
    setDisplayList(enquiriesHistory);
  }, [enquiriesHistory]);

  useEffect(() => {
    filterData(searchDate, keyword, statusFilter);
  }, [keyword, activeTab, enquiriesHistory, searchDate, statusFilter]);

  const filterData = (date, keywordValue, status) => {
    let filteredData = Array.isArray(enquiriesHistory) ? enquiriesHistory : [];

    if (date) {
      const today = new Date(date);
      filteredData = filteredData.filter((data) => {
        const bookingDate = new Date(data.bookingTime);
        return (
          bookingDate.getFullYear() === today.getFullYear() &&
          bookingDate.getMonth() === today.getMonth() &&
          bookingDate.getDate() === today.getDate()
        );
      });
    }

    filteredData = filteredData.filter((item) =>
      matchesHistoryStatusFilter(item, status)
    );

    if (keywordValue && keywordValue.length !== 0) {
      const kw = keywordValue.toLowerCase();
      filteredData = filteredData.filter(
        (item) =>
          item?.name?.toLowerCase?.().includes(kw) ||
          item?.email?.toLowerCase?.().includes(kw) ||
          item?.formattedID?.toLowerCase?.().includes(kw) ||
          String(item?.phone || "").includes(keywordValue)
      );
    }

    setDisplayList(filteredData);
  };

  const emptyMessage =
    statusFilter === "all"
      ? "No Enquiries"
      : `No ${statusFilter} enquiries`;

  return (
    <Fragment>
      <EnquiryListPanel
        title="History"
        items={displayList}
        loading={reservationLoading}
        emptyMessage={emptyMessage}
        showStatus
      />
    </Fragment>
  );
}

export default EnquiriesHistory;
